import { ICONS, isIcon, hasIcon } from 'Components/utils/icon/icons';
import { LOADERS } from './loaders';
type IconName = (string | null | undefined) | null;

const parseName = (name: IconName): string | null => {
  if (name == null) {
    return null;
  }

  const lowerName = name.toLowerCase();

  if (hasIcon(name)) {
    return ICONS[name];
  }

  if (hasIcon(lowerName)) {
    return ICONS[lowerName];
  }

  if (isIcon(name)) {
    return name;
  }

  if (isIcon(lowerName)) {
    return lowerName;
  }

  return null;
};

export const getLoader = (iconName: IconName) => {
  const name = parseName(iconName);

  if (name === null) {
    return null;
  }

  return LOADERS[name] ?? null;
};
